import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import { TextValidator } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ServiceAxios } from '../../../../services/ServiceEW';
import { ServiceValues } from '../../../../values/ServiceValues';
import { useStyles } from './PacoteRegisterInfoStyles';
import Alert from '@material-ui/lab/Alert';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import DeleteIcon from '@material-ui/icons/Delete';


function PacoteRegisterInfo(props) {
  const {
    pacote,
    setPacote,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    edicao
  } = props;
  const [descricao, setDescricao] = useState(props.pacote.descricao);
  const [valor, setValor] = useState(props.pacote.valor);
  const [valorCartao, setValorCartao] = useState(props.pacote.valorVendaCartao);
  const [quantidadeDisparos, setQuantidadeDisparos] = useState(props.pacote.quantidadeDisparos);
  const [numeroPacote, setNumeroPacote] = useState();
  const [numeroNotaFiscal, setnumeroNotaFiscal] = useState();
  const [idCalibre, setidCalibre] = useState();
  const [armaSelecionada, setArmaSelecionada] = useState();
  const [openDialogFinish, setOpenDialogFinish] = React.useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [calibres, setCalibres] = useState([]);
  const [resfreshState, setRefreshState] = useState(new Date());
  const loadingCalibres = openAutocomplete && calibres.length === 0;
  const baseUrl = ServiceValues.base_url_local;
  const timeout = ServiceValues.timeout;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();


  useEffect(() => {
    let active = true;
    if (!loadingCalibres) {
      return undefined;
    }
    (async () => {
      const params = {
        limit: 5000,
      };
      let dados = await api.get('armas/', {params: params});
      dados = dados.data.result;
      if (active) {
        setCalibres(dados);
      }
    })();
    return () => {
      active = false;
    };
  }, [loadingCalibres]);


  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };


  function modificarValores(order, value){
    switch (order) {
      case 0:
        pacote.descricao = value;
        setPacote(pacote);
        setDescricao(value);
        break;
      case 1:
        pacote.valor = value;
        setPacote(pacote);
        setNumeroPacote(value);
        break;
      case 2:
        pacote.acrescimosCartao = true;
        pacote.valorVendaCartao = value;
        setPacote(pacote);
        setnumeroNotaFiscal(value);
        break;
      case 3:
        pacote.quantidadeDisparos = value;
        setPacote(pacote);
        setidCalibre(value);
        break;
    }
    setPacote(pacote);
  }

  function aoModificarArma(event, arma) {
    if(arma){
      setArmaSelecionada(arma);
      setPacote(pacote);
    }
    else{
      setArmaSelecionada(null);
      setPacote(pacote);
    }
    setRefreshState(new Date());
  }

  function aoAdicionarArma(arma) {
    if(!pacote.armas.includes(arma)){
      pacote.armas.push(arma);
      setPacote(pacote);
      setRefreshState(new Date());
    }
    else{
      setMessageSnack('Arma já está inclusa no pacote');
      setTypeSnack('warning');
      setShowMessageSnack(true);
    }
  }

  function deleteArma(index) {
    if(edicao){
      pacote.armas[index].deletado = true;
      setPacote(pacote);
      setRefreshState(new Date());
    }
    else{
      pacote.armas.splice(index, 1);
      setPacote(pacote);
      setRefreshState(new Date());
    }
  }
  return (
    <div>
      <CardHeader
        title="Pacote"
        subheader="Informe as seguintes informações do pacote"
      />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          {armaSelecionada && !armaSelecionada.calibre.permitido &&
          <Grid
            item
            md={12}
            xs={12}
          >
            <Alert
              severity="warning"
              variant="standard"
            >
              ATENÇÃO: O CALIBRE DESSA ARMA É CONSIDERADO RESTRITO
            </Alert>

          </Grid>
          }

          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Descrição"
              helperText="Insira a descrição do pacote."
              margin="dense"
              name="razaoSocial"
              value={pacote.descricao}
              onChange={e => modificarValores(0, e.target.value)}
              variant="outlined"
              // validators={['required', 'maxStringLength:155']}
              // errorMessages={['Informe a descrição!', 'Descrição muito longa!']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Valor"
              helperText="Insira o valor do pacote à vista."
              margin="dense"
              name="Valor"
              value={pacote.valor}
              onChange={e => modificarValores(1, e.target.value)}
              variant="outlined"
              // validators={['required']}
              // errorMessages={['Informe o número da pacote!']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Valor no cartão de crédito"
              helperText="Insira valor do pacote no cartão de crédito."
              margin="dense"
              name="email"
              value={pacote.valorVendaCartao}
              onChange={e => modificarValores(2, e.target.value)}
              variant="outlined"
              // validators={['required']}
              // errorMessages={['Informe o número da nota fiscal da pacote!']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Quantidade de disparos"
              helperText="Insira a quantidade de disparos deste pacote."
              margin="dense"
              value={pacote.quantidadeDisparos}
              onChange={e => modificarValores(3, e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <Autocomplete
              size={'small'}
              id="autocomplete_calibre"
              open={openAutocomplete}
              value={armaSelecionada}
              onOpen={() => {
                setOpenAutocomplete(true);
              }}
              onClose={() => {
                setOpenAutocomplete(false);
              }}
              onChange={aoModificarArma}
              getOptionSelected={(option, value) => option.descricao === option.descricao}
              getOptionLabel={option => option.descricao}
              options={calibres}
              loading={loadingCalibres}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Armas"
                  fullWidth
                  margin={'dense'}
                  value={armaSelecionada}
                  variant="outlined"
                  helperText={'Selecione as armas do pacote.'}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingCalibres ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <Button
              color="primary"
              variant="contained"
              style={{
                marginTop: 10
              }}
              onClick={event => aoAdicionarArma(armaSelecionada)}
            >
              Adicionar arma
            </Button>
          </Grid>
          <Grid item md={3} xs={12}/>

            {pacote.armas.map((arma, index) => {
              return !arma.deletado && <Grid
                  item
                  md={3}
                  xs={12}
                >
                  <Card
                    row variant="outlined"
                    style={{
                      minHeight: 200
                    }}
                  >
                    <CardContent
                      style={{
                        minHeight: 130
                      }}
                    >

                      <Typography variant="h5" component="h2">
                        Descricao: {arma.descricao}
                      </Typography>
                      <Typography variant="h10" component="h10">
                        {`Calibre: ${arma.calibre.descricao}`}
                      </Typography>

                      {
                        !arma.calibre.permitido &&
                        <Alert
                          style={{
                            marginTop: 5
                          }}
                          severity="warning"
                          variant="standard"
                        >
                          Calibre restrito
                        </Alert>
                      }
                    </CardContent>
                    <CardActions>
                      <div>
                        <Button
                          variant="text"
                          className={classes.buttonDelete}
                          startIcon={<DeleteIcon />}
                          onClick={e => deleteArma(index)}
                        >
                          REMOVER ARMA DO PACOTE
                        </Button>
                      </div>
                    </CardActions>
                  </Card>
              </Grid>
            })}
          </Grid>
      </CardContent>
      <Divider />

    </div>
  );
};

PacoteRegisterInfo.propTypes = {
  className: PropTypes.string,
  pacote: PropTypes.object.isRequired
};

export default PacoteRegisterInfo;


